import {
    REVOKE_TOKEN_START,
    REVOKE_TOKEN_COMPLETE,
    REVOKE_TOKEN_ERROR,
  } from './actions';
  
  let initialState = {
    revokeTokenStarted: false,
    logoutError: undefined,
  };
  
  const reducer = (state = initialState, { payload, type }) => {
    switch (type) {
      case REVOKE_TOKEN_START:
        return {
          ...state,
          revokeTokenStarted: true,
          logoutError: undefined,
        };
      case REVOKE_TOKEN_COMPLETE:
        return {
          ...state,
          revokeTokenStarted: false,
          logoutError: undefined,
        };
      case REVOKE_TOKEN_ERROR:
        return {
          ...state,
          logoutError: payload.error,
          revokeTokenStarted: false,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  